import { render, staticRenderFns } from "./discord-room.vue?vue&type=template&id=5a4f5078&scoped=true"
import script from "./discord-room.vue?vue&type=script&lang=js"
export * from "./discord-room.vue?vue&type=script&lang=js"
import style0 from "./discord-room.vue?vue&type=style&index=0&id=5a4f5078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4f5078",
  null
  
)

export default component.exports